"use client"

import styled from "@emotion/styled"
import { Button } from "@mui/material"
import Container from "ui/Container"
import { getNonUmbracoUrl, Link } from "utils"
import { extractProperty } from "utils/extractProperty"

const StyledContainer = styled.div<{ isLast?: boolean }>`
  width: 100%;
  padding-bottom: 48px;
  ${({ theme }) => theme.breakpoints.down("md")} {
    display: flex;
    justify-content: center;
  }
  ${({ theme, isLast }) => theme.breakpoints.up("md")} {
    padding-bottom: ${({ isLast }) => (isLast ? "84px" : "48px")};
  }
`
const StyledButton = styled(Button)<{ target?: string }>`
  width: 218px;
`

export default function ButtonComp({
  data,
  isLast = true,
}: {
  data: any
  isLast?: boolean
}) {
  const buttonName = extractProperty(data, "button")?.[0]?.name
  const buttonUrl = extractProperty(data, "button")?.[0]?.url
  const target = extractProperty(data, "button")?.[0]?.target
  return (
    <Container paddingMobile={true}>
      {buttonUrl && (
        <StyledContainer isLast={isLast}>
          <StyledButton
            variant="secondary"
            LinkComponent={Link}
            href={getNonUmbracoUrl(buttonUrl)}
            target={target}
          >
            {buttonName}
          </StyledButton>
        </StyledContainer>
      )}
    </Container>
  )
}
